/** The name of the module */
export const name = 'DataLayer';
export var Layout;
(function (Layout) {
    Layout["MobileWeb"] = "Mobile3";
    Layout["WebView"] = "App WebView";
    Layout["Classic"] = "Classic";
    Layout["Redesign"] = "Redesign";
    Layout["Extension"] = "Extension";
})(Layout || (Layout = {}));
export default class DataLayer {
    // TODO: Add error reporting to this to catch any instances where window.dataLayer doesn't exist yet
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static get(propertyName) {
        if (!Object.prototype.hasOwnProperty.call(window.dataLayer, propertyName)) {
            throw new Error(`Invalid property name (${propertyName}) specified.`);
        }
        return window.dataLayer[propertyName];
    }
}
